export default __webpack_public_path__ + "static/media/empty-archive-img.e53ac990.svg";